import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import { Button } from "primereact/button";
import "./css/ConfirmationModal.css";
import { Dropdown } from "primereact/dropdown";
import { confirmationModalObject } from "./ConfirmationModal.class";

const onSaveConfrimationModal = (selection = '', onSave, onBack) => {
  if (["yes", "no"].includes(selection)) {
    confirmationModalObject.isConfirmationModalOpen = false;
    onSave(selection);
    if (selection === "no") {
      onBack();
    }
  }
};

const ConfirmationModal = ({
  isOpen,
  onBack,
  onSave,
  confirmLabel,
  options,
  setSelectedOption,
}) => {
  const [selection, setSelection] = useState(options[0]?.value || "");
   const inputRef = useRef();

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelection(newValue);
    setSelectedOption(newValue);
    inputRef.current?.focus?.();
  };

  const backButtonHandler = () => {
    onBack();
    confirmationModalObject.isConfirmationModalOpen = false;
  };

  const handleKeyPress = (event) => {
    if (event.key === "F12" && isOpen) {
      event?.preventDefault();
      backButtonHandler();
    }
  };

  useEffect(() => {
    if (isOpen) {
      confirmationModalObject.isConfirmationModalOpen = true;
      window.addEventListener("keydown", handleKeyPress);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      // onRequestClose={onRequestClose}
      contentLabel="Confirmation Modal"
      className="modalContent"
      overlayClassName="modalOverlay"
    >
      {/* <div className="modalFooter">
        <a
          href="https://rxclaim-nextgen-qa.optum.com/help//index.htm#t=Price%2FRCPMT001.htm"
          className="helpLink"
        >
          Help
        </a>
      </div> */}
      <div className="modalHeaderContainer">
        <Button
          outlined
          onClick={backButtonHandler}
          severity="secondary"
          label="Back"
          size="small"
          tooltip="F12"
          pt={{
            root: {
              className: "confirmationBackButtonIcon",
            },
          }}
        />

        <Button
          label={"Save"}
          severity="primary"
          onClick={onSaveConfrimationModal.bind(
            null,
            selection,
            onSave,
            onBack
          )}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              onSaveConfrimationModal(selection, onSave, onBack);
            }
          }}
        />
      </div>
      <div className="grid">
        <h2 className="header-modal">
          Confirm Prompt-<span className="blueText">RCPMT001</span>
        </h2>
      </div>
      <div className="grid">
        <div className="grid-item">
          <label>{confirmLabel}</label>
        </div>
        <div className="grid-item">
          <Dropdown
            focusInputRef={inputRef}
            value={selection}
            onChange={handleSelectionChange}
            options={options}
            optionLabel="label"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;